import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { StorageProvider } from '../../http/storage-service';
import { Constants } from '../../constants/constants';
import { Messages } from '../../messages/messages';

@Injectable()
export class LoggingService {
  appInsights: ApplicationInsights;
  constructor(private storageProvider: StorageProvider) {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment.appInsights.instrumentationKey,
        enableAutoRouteTracking: false // option to log all route changes
      }
    });
    this.appInsights.loadAppInsights();
  }

  logException(exception: Error) {
    let userId = '';
    const loggedInUserData = this.storageProvider.getSessionStorageData(Constants.LoggedInUserData);
    if (loggedInUserData) {
      userId = loggedInUserData.user.userId;
    }
    let errorMessage = 'Internal code error';
    if (exception) {
      errorMessage = exception.message;
    }
    if ((errorMessage.indexOf(Messages.AzureException)) <= -1) {
      this.appInsights.trackException({
        exception: new Error('FE Error - Employee: ' + userId + ', Error Message: ' + errorMessage)
      });
    }
  }
}
